import { Permissions } from 'src/app/models/Enums/Permissions';
import { Roles } from 'src/app/models/Enums/Roles';

export const RolePermissionsMap: Record<Roles, Permissions[]> = {
  [Roles.SalesAdmin]: [
    // Filters
    Permissions.SHOW_RSA_FILTER,
    Permissions.SHOW_ISR_FILTER,
    Permissions.SHOW_DEALER_FILTER,

    // Default Filters
    Permissions.DEFAULT_TO_RSA_FILTER,

    // Columns
    Permissions.SHOW_RSA_COLUMN,
    Permissions.SHOW_ISR_COLUMN,
    Permissions.SHOW_DEALER_COLUMN,

    // Order
    Permissions.CAN_ADD_ORDER,
    Permissions.CAN_DELETE_ORDER,

    // Transfers
    Permissions.CAN_ADD_NEW_TRANSFER,

    // Products
    Permissions.CAN_MODIFY_PRODUCT,
  ],
  [Roles.RSA]: [
    // Filters
    Permissions.SHOW_ISR_FILTER,
    Permissions.SHOW_DEALER_FILTER,

    // Default Filters
    Permissions.DEFAULT_TO_ISR_FILTER,

    // Columns
    Permissions.SHOW_ISR_COLUMN,
    Permissions.SHOW_DEALER_COLUMN,

    // Order
    Permissions.CAN_ADD_ORDER,
    Permissions.CAN_MODIFY_ORDER,
    Permissions.CAN_DELETE_ORDER,

    // Transfers
    Permissions.CAN_ADD_NEW_TRANSFER,
  ],
  [Roles.ISR]: [
    // Filters
    Permissions.SHOW_DEALER_FILTER,

    // Default Filters
    Permissions.DEFAULT_TO_DEALER_FILTER,

    // Columns
    Permissions.SHOW_DEALER_COLUMN,

    // Order
    Permissions.CAN_ADD_ORDER,
    Permissions.CAN_MODIFY_ORDER,

    // Transfers
    Permissions.CAN_ADD_NEW_TRANSFER,
  ],
  [Roles.SalesSupport]: [
    // Filters
    Permissions.SHOW_RSA_FILTER,
    Permissions.SHOW_ISR_FILTER,
    Permissions.SHOW_DEALER_FILTER,

    // Default Filters
    Permissions.DEFAULT_TO_RSA_FILTER,

    // Columns
    Permissions.SHOW_RSA_COLUMN,
    Permissions.SHOW_ISR_COLUMN,
    Permissions.SHOW_DEALER_COLUMN,

    // Order
    Permissions.CAN_ADD_ORDER,
    Permissions.CAN_DELETE_ORDER,

    // Transfers
    Permissions.CAN_ADD_NEW_TRANSFER,

    // Products
    Permissions.CAN_MODIFY_PRODUCT,
  ],
  [Roles.DivisionManager]: [
    // Filters
    Permissions.SHOW_RSA_FILTER,
    Permissions.SHOW_ISR_FILTER,
    Permissions.SHOW_DEALER_FILTER,

    // Default Filters
    Permissions.DEFAULT_TO_RSA_FILTER,

    // Columns
    Permissions.SHOW_RSA_COLUMN,
    Permissions.SHOW_ISR_COLUMN,
    Permissions.SHOW_DEALER_COLUMN,

    // Order
    Permissions.CAN_ADD_ORDER,
    Permissions.CAN_DELETE_ORDER,

    // Transfers
    Permissions.CAN_ADD_NEW_TRANSFER,
  ],
};
